export const SET_DOCUMENT_TITLE = (title) => {
    document.title = title;
}

export const SET_DOCUMENT_DIR = (dir) => {
    document.documentElement.setAttribute('dir', dir)
}
export const SET_DOCUMENT_LANG= (lang) => {
    document.documentElement.setAttribute('lang', lang)
}
